import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_HOW_TO_APPLY_ERROR, GET_HOW_TO_APPLY_START, GET_HOW_TO_APPLY_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/how-to-apply/${payload.lang}` : '/how-to-apply';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_HOW_TO_APPLY_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_HOW_TO_APPLY_ERROR, error });
  }
}

export default function* get_how_to_apply() {
  yield takeLatest(GET_HOW_TO_APPLY_START, get);
}

